// ── קישור שנסרק בפריסה עברית ────────────────────────────────────────────────
//
// הסורק הוא מקלדת: הוא שולח את מקשי הפריסה האנגלית, ווינדוס בפריסה עברית
// מתרגם אותם. ה-QR על תג העובד מחזיק קישור (`https://…/scan?badge=22`), ונמדד
// בדפדפן 03/10/2026: בפריסה עברית הוא מגיע כ-`יאאפד://…` → „עובד לא נמצא"
// בכל הקיוסקים. (`ץ` במקום נקודה — מק״ט — מטופל בנפרד, `fixScannerLayout`.)
//
// ממירים **רק** מחרוזת שמתחילה ב-http בפריסה עברית: שם כל תו הגיע מהפריסה
// העברית, ולכן ההמרה ההפוכה חד-משמעית (`.`←`/`, `ץ`←`.`). מחרוזת אחרת לא
// נוגעים בה — מיפוי כללי היה הופך נקודה תקינה במק״ט ל-`/`.
const HE_TO_US = {
    '/': 'q', "'": 'w', 'ק': 'e', 'ר': 'r', 'א': 't', 'ט': 'y', 'ו': 'u', 'ן': 'i', 'ם': 'o', 'פ': 'p',
    'ש': 'a', 'ד': 's', 'ג': 'd', 'כ': 'f', 'ע': 'g', 'י': 'h', 'ח': 'j', 'ל': 'k', 'ך': 'l', 'ף': ';',
    'ז': 'z', 'ס': 'x', 'ב': 'c', 'ה': 'v', 'נ': 'b', 'מ': 'n', 'צ': 'm', 'ת': ',', 'ץ': '.', '.': '/',
};
/** `יאאפ` = http. כל קישור שלנו מתחיל כך. */
const HEBREW_HTTP = /^יאאפד?:/;
export function unHebrewUrl(raw) {
    const t = raw.trim();
    if (!HEBREW_HTTP.test(t))
        return t;
    return [...t].map((c) => HE_TO_US[c] ?? c).join('');
}
// ── מדבקת כלי (מנכ"ל 01/11/2026) ────────────────────────────────────────────
//
// מה שהסורק יכול למסור על אותה מדבקה: הקישור שעל ה-QR (`https://…?tool=T-0012`,
// גם בפריסה עברית), ה-QR הישן שעל מדבקות שכבר מודבקות (`TOOL:T-0012`, ובפריסה
// עברית `אםםך:א-0012`), והמספר המודפס. מקום אחד, לשרת ולדפדפן.
const STICKER = /^(?:TOOL:|אםםך:)?[Tא]-?0*(\d{1,6})$/i;
/** הקישור שעל ה-QR, `TOOL:…` או המספר → „T-0012"; אחרת null. */
export function toolStickerOf(raw) {
    let t = unHebrewUrl(raw.trim());
    if (/^https?:/i.test(t)) {
        try {
            t = new URL(t).searchParams.get('tool')?.trim() ?? '';
        }
        catch {
            return null;
        }
    }
    const m = STICKER.exec(t);
    return m ? `T-${m[1].padStart(4, '0')}` : null;
}
/** סריקה שלמה של מדבקת כלי — מספיק כדי לפעול בלי Enter. `…tool=T-0` באמצע הקלדה עדיין לא. */
export function isToolScan(raw) {
    const t = raw.trim();
    return /\d{4,6}$/.test(t) && toolStickerOf(t) !== null;
}
